import { InspectionAssignmentOverviewDTO } from "../../../common/types/common.dto.types";
import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";

const client = new ApiClient();

export const getAssignedInspectionsApi = async (
  searchParameter: InspectionAssignmentOverviewDTO
): Promise<ActionResponseType> => {
  try {
    const URL: string = `InspectionAssignmentOverview/GetAssignedInspections`;
    let result: ActionResponseType = {} as ActionResponseType;
    await client
      .post<ActionResponseType>(URL, searchParameter)
      .then((response: ActionResponseType) => {
        result = response;
      })
      .catch((error) => {
        result = {} as ActionResponseType;
      });

    return result;
  } catch (error) {
    throw error;
  }
};

export const getAssignedInspectionStatisticsApi = async (
  searchParameter: InspectionAssignmentOverviewDTO
): Promise<ActionResponseType> => {
  try {
    const URL: string = `InspectionAssignmentOverview/GetAssignedInspectionStatistics`;
    let result = {} as ActionResponseType;
    await client
      .post<ActionResponseType>(URL, searchParameter)
      .then((response: ActionResponseType) => {
        result = response;
      })
      .catch((error) => {
        result = {} as ActionResponseType;
      });

    return result;
  } catch (error) {
    throw error;
  }
};
